import { createSlice } from "@reduxjs/toolkit";
import { signin, updateAdminProfile } from "../thunks/authThunks";
import { roles } from "../../constants/commonConstants";

// Load authentication state from localStorage (if exists)
const storedAuth = JSON.parse(localStorage.getItem("auth")) || {};

const initialState = {
  isAuthenticated: storedAuth.isAuthenticated || false,
  user: storedAuth.user || null,
  role: storedAuth.role || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // NOTE: Signout
    signout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.role = roles.REMIXER;
      localStorage.removeItem("auth");
      localStorage.removeItem("token");
      localStorage.setItem("auth",JSON.stringify({role:roles.REMIXER}));
    },
  },
  extraReducers: (builder) => {
    // NOTE: Signin
    builder.addCase(signin.fulfilled, (state, action) => {
      handleAuthSuccess(state, action.payload.data);
    });
    // NOTE: Update Admin Profile
    builder.addCase(updateAdminProfile.fulfilled, (state, action) => {
      const { name, email, contactNumber } =
        action?.payload?.data;
      state.user = {
        ...state.user,
        name,
        email,
        contactNumber,
      };

      localStorage.setItem(
        "auth",
        JSON.stringify({
          isAuthenticated: true,
          user: {
            ...state.user,
            name,
            email,
            contactNumber,
          },
        })
      );
    });
  },
});

// handle authentication success
const handleAuthSuccess = (state, data) => {
  const { userData,token } = data;
  
  const decodedToken=decodeToken(token);
  console.log("Decoded Token",decodedToken);
  
  state.role = decodedToken?.roles?.[0] || roles.REMIXER;
  state.isAuthenticated = true;
  state.user = userData;

  localStorage.setItem(
    "auth",
    JSON.stringify({
      isAuthenticated: true,
      user: userData,
      role:state.role,
    })
  );
};

// Helper function to decode JWT token
const decodeToken = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (error) {
    console.error("Error decoding token:", error);
    return {};
  }
};


export const { signout } = authSlice.actions;
export default authSlice.reducer;
